export function joinPaths(...parts: (string | null)[]): string {
    const segments = parts.flatMap((part) => {
        if (part === null) return [];
        return part.split("/").filter((segment) => segment !== "");
    });
    return `/${segments.join("/")}`;
}

export function matchPath(pattern: string, pathname: string, mode: "exact" | "prefix"): boolean {
    const patternSegments = pattern.split("/").filter((segment) => segment !== "");
    const pathSegments = pathname.split("/").filter((segment) => segment !== "");

    if (patternSegments.length > pathSegments.length) return false;
    if (mode === "exact" && patternSegments.length !== pathSegments.length) return false;

    return patternSegments.every((patternSegment, index) => {
        const pathSegment = pathSegments[index];
        if (pathSegment === undefined) return false;
        if (patternSegment.startsWith(":")) return true;
        return patternSegment === pathSegment;
    });
}
